export default "__VITE_ASSET__BQwhoPlF__"